import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchSignalProviderList = async (user) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/signal-providers/list`,
      buildHeaders(user)
    );
    return data;
  } catch (error) {
    throw error
  }
}